import { render, staticRenderFns } from "./EnableEmail.vue?vue&type=template&id=231ab771&scoped=true&"
import script from "./EnableEmail.vue?vue&type=script&lang=ts&"
export * from "./EnableEmail.vue?vue&type=script&lang=ts&"
import style0 from "./EnableEmail.vue?vue&type=style&index=0&id=231ab771&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231ab771",
  null
  
)

export default component.exports